module.exports = __webpack_public_path__ + "static/media/PK.566ca9a9.png";